import React from "react";

interface ToggleProps {
  toggled: boolean;
  changeToggle: () => void;
  label?: React.ReactNode;
  disabled?: boolean;
  color?: "blue" | "green";
}

export function Toggle({ toggled, changeToggle, label, disabled = false, color = "blue" }: ToggleProps) {
  const trackBg = toggled
    ? color === "green" ? "bg-success-green-500" : "bg-cornflower-blue-500"
    : "bg-gray-200";

  return (
    <div className="flex gap-2 items-center">
      <button
        type="button"
        role="switch"
        aria-checked={toggled}
        onClick={disabled ? undefined : changeToggle}
        disabled={disabled}
        className={`relative inline-flex items-center w-8 h-4 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-cornflower-blue-300 ${trackBg} ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
      >
        <span
          className={`absolute w-3 h-3 bg-white rounded-full shadow transition-transform ${toggled ? "translate-x-[18px]" : "translate-x-[2px]"}`}
        />
      </button>
      {label && (
        <label
          onClick={disabled ? undefined : changeToggle}
          className={`cursor-pointer select-none ${toggled ? "text-blue-500" : "text-slate-500"}`}
        >
          {label}
        </label>
      )}
    </div>
  );
}
